import {
  ScrollView,
  TouchableOpacity,
  TextInput,
  Modal,
  Image,
  Text,
  View,
} from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { AppScreens } from "../../../Utility/AppScreens";
import PaymentScreen from "../BeltScreens/PaymentScreen";
import PurchaseSuccessModal from "./PurchaseSuccessModal";
import StreamerViewComponent from "../../../../Components/notification-common-components/StreamerViewComponent";
import DescriptionScrollView from "../../../../Components/notification-common-components/DescriptionScrollView";
import {
  createWatchingEvent,
  ticketEvent,
} from "../../../../services/eventsAPI";
import { toast } from "react-toastify";
import { handleApiError } from "../../../../services/errorHandler";
import { format } from "date-fns";
import { getUserProfile } from "../../../../services/authAPI";
import Separator from "../../../../Components/Separator";
export default function BuyTicketModal({
  closeButTicket,
  accessToken,
  item,
  userData,
  userProfileData,
  setIsGetTicket,
}) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [isVisble, setIsVisible] = useState(false);
  const [isPurchaseSuccess, setIsPurchaseSuccess] = useState(false);

  const [organiser, setOrganiser] = useState("My ticket");
  const [promotionCode, setPromotionCode] = useState("");
  // const [price, setPrice] = useState("");
  const [updateShowLoader, setUpdateShowLoader] = useState(false);
  const date = useMemo(
    () => new Date(item?.startDateTime),
    [item?.startDateTime]
  );
  const formattedDate = item?.startDateTime
    ? format(date, "do MMM, h:mmaaa")
    : "No date available";
  const callTicketEventAPI = async () => {
    setUpdateShowLoader(true);

    const bodyParams = {
      accessToken: accessToken,
      eventID: item.eventID,
      newAttendeeIDs: [userData.username],
      token: Number(item?.ticketPrice),
    };

    try {
      const response = await ticketEvent(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          setUpdateShowLoader(false);
          callWatchingEventAPI();
          toast.success(response.body.message);
        }
      } else {
        toast.error(response.body.error);
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      setUpdateShowLoader(false);
    }
  };
  const callWatchingEventAPI = async () => {
    setUpdateShowLoader(true);
    const bodyParams = {
      accessToken: accessToken,
      eventId: item.eventID,
    };
    try {
      const response = await createWatchingEvent(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          setIsPurchaseSuccess(true);
          setUpdateShowLoader(false);
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      setUpdateShowLoader(false);
      toast.error(error.message);
    }
  };
  const remaingBalance =
    Number(userProfileData.tokens) > 0
      ? Number(userProfileData.tokens) - Number(item?.ticketPrice)
      : "Not valid Token";

  return (
    <Modal transparent={true} visible={true}>
      <View style={styles.container}>
        <ScrollView
          style={styles.mainView}
          showsHorizontalScrollIndicator={false}
        >
          <View style={styles.allView}>
            <View style={styles.wrraperView}>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XL
                    ? AppFontStyle.BOLD_ANYBODY_32
                    : AppFontStyle.BOLD_ANYBODY_24,
                  { flex: 1 },
                ]}
              >
                Buy tickets
              </Text>
              <TouchableOpacity
                onPress={() => setIsGetTicket(false)}
                style={{
                  backgroundColor: AppColors.grayColor_393939,
                  width: 28,
                  height: 28,
                  borderRadius: 10,
                }}
              >
                <Image
                  source={AppImages.icCancel}
                  style={{
                    height: 12,
                    width: 12,
                    alignSelf: "center",
                    marginVertical: 7,
                  }}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>
            <View
              style={{
                height: 1,
                backgroundColor: AppColors.grayColor_333333,
              }}
            />
            <View style={styles.deviceDirection}>
              <View style={{ flex: 1 }}>
                <View
                  style={{
                    flexDirection: "row",
                    marginVertical: 15,
                    alignItems: "center",
                  }}
                >
                  <Text style={[AppFontStyle.BOLD_ANYBODY_16, { flex: 1 }]}>
                    {item?.title}
                  </Text>
                  <View
                    style={{
                      paddingHorizontal: 18,
                      paddingVertical: 5,
                      borderRadius: 7,
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                    }}
                  >
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_12, {}]}>
                      {formattedDate}
                    </Text>
                  </View>
                </View>

                <View style={styles.streamerView}>
                  <StreamerViewComponent
                    styles={styles}
                    setIsShare={() => {}}
                    participants={item?.participantDetails}
                    attendees={item?.attendeeIDs}
                  />
                </View>
                <View style={{ marginVertical: 10 }}>
                  <DescriptionScrollView
                    styles={styles}
                    details={item}
                    maxHeightScreen={250}
                  />
                </View>
              </View>

              {deviceSize !== DEVICE_SIZES.XS && (
                <View
                  style={{
                    width: 2,
                    // height: "110%",
                    backgroundColor: AppColors.grayColor_333333,
                    marginHorizontal: 10,
                  }}
                />
              )}

              <View style={{ flex: 1 }}>
                <View
                  style={{
                    height: 80,
                    backgroundColor: AppColors.grayColor_333333,
                    borderRadius: 10,
                    paddingHorizontal: 7,
                    paddingVertical: 10,
                    marginTop: 15,
                  }}
                >
                  {/* <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.gray_C3C3C3 },
                    ]}
                  >
                    {userProfileData.userID}'s token
                  </Text> */}
                  <View style={{ marginTop: 15, flexDirection: "row" }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.gray_C3C3C3, marginRight: 20 },
                      ]}
                    >
                      Token Balance
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        { color: AppColors.white },
                      ]}
                    >
                      {userProfileData.tokens}
                    </Text>
                    <Image
                      source={AppImages.icWonDollarIcon}
                      style={{
                        height: 13,
                        width: 13,
                        alignSelf: "center",
                        marginHorizontal: 7,
                        borderWidth: 1,
                        borderRadius: 25,
                        borderColor: AppColors.yellow_F5F865,
                      }}
                      resizeMode="contain"
                    />
                  </View>
                  <CommonButton
                    title="Top-Up"
                    onTap={() => {
                      setIsGetTicket(false);
                      navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                          eventID: item.eventID,
                          type: "home",
                        });
                    }}
                    buttonStyle={styles.btnTopUpStyle}
                    textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                  />
                </View>
                {/* Promotion code: Text/TextInput */}

                <View style={{}}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Promotion code
                  </Text>
                  <TextInput
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        backgroundColor: AppColors.grayColor_333333,
                        borderRadius: 10,
                        paddingHorizontal: 7,
                        paddingVertical: 20,
                        marginTop: 5,
                      },
                    ]}
                    placeholderTextColor={AppColors.gray_C3C3C3}
                    placeholder="Promotion code"
                    value={promotionCode}
                    onChangeText={(text) => {
                      setPromotionCode(text);
                    }}
                  />
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Ticket Price
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {item?.ticketPrice}
                  </Text>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Balance
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {userProfileData.tokens}
                  </Text>
                </View>
                <View style={{ marginTop: 13 }}>
                  <Separator
                    color={AppColors.grayColor_333333}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.gray_C3C3C3, marginTop: 25 },
                    ]}
                  >
                    Remaining balance
                  </Text>

                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { color: AppColors.white, marginTop: 25 },
                    ]}
                  >
                    {remaingBalance}
                  </Text>
                </View>

                <View style={{ flexDirection: "row", gap: 40 }}>
                  <CommonButton
                    title="Purchase"
                    onTap={async () => {
                      await callTicketEventAPI();
                    }}
                    disabled={updateShowLoader}
                    buttonStyle={styles.btnSignUpStyle}
                    textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                  />
                </View>
              </View>
            </View>
          </View>
          {isPurchaseSuccess && (
            <PurchaseSuccessModal
              closeButTicket={closeButTicket}
              item={item}
              token={item?.ticketPrice}
              openPurchaseSuccess={isPurchaseSuccess}
              closePurchaseSuccess={() => {
                setIsGetTicket(false);
                setIsPurchaseSuccess(false);
              }}
            />
          )}
        </ScrollView>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    // detailTextStyle: { marginVertical: 15 },
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      // padding: 30,
      width: "50%",

      marginHorizontal: 40,
      marginVertical: 100,
      alignSelf: "center",
      // flex: 1,
    },
    allView: {
      borderRadius: 10,
      backgroundColor: AppColors.gray_1E1E1E,
      paddingTop: 10,
      paddingHorizontal: 30,
      paddingBottom: 30,
    },
    wrraperView: {
      flexDirection: "row",
      paddingVertical: 20,
    },
    streamerView: {
      backgroundColor: AppColors.grayColor_333333,
      //   height: "35%",
      borderRadius: 10,
    },
    streamViewStyle: {
      //   backgroundColor: AppColors.appBlackColor_1e1e1e,
      width: "100%",
      borderRadius: 10,
      paddingVertical: 9,
      paddingHorizontal: 11,
      gap: 10,
    },
    priceView: {
      backgroundColor: AppColors.grayColor_333333,
      marginTop: 5,
      borderRadius: 10,
      width: "50%",
    },
    detailTextStyle: {
      // width: "50%",
      height: 100,
    },
    btnTopUpStyle: {
      marginBottom: 10,
      paddingVertical: 0,
      paddingHorizontal: 20,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 30,
      borderRadius: 7,
      alignSelf: "flex-end",
      // top: 10,
    },
    btnSignUpStyle: {
      marginVertical: 10,
      paddingVertical: 0,
      paddingHorizontal: 20,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      height: 30,
      borderRadius: 7,
      alignSelf: "center",
      top: 10,
    },
    textInput: {
      paddingVertical: 12,
      paddingHorizontal: 60,
      backgroundColor: AppColors.black,
      margin: 5,
      borderRadius: 10,
      // justifyContent:"center",
      // alignSelf:"center"
    },
    deviceDirection: {
      flexDirection: "row",
    },
    btnGetTicketStyle: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      flexGrow: 1,
      height: 40,
      borderRadius: 10,
    },
    playersView: {
      flexDirection: "row",
      gap: 10,
      justifyContent: "space-evenly",
    },
    playerView: {
      borderRadius: 12,
      alignItems: "center",
    },
    playerImg: {
      height: 104,
      width: 93,

      marginVertical: 10,
    },
    vsImage: {
      width: 50,
      height: 100,
      marginVertical: 10,
    },
  },

  {
    [DEVICE_SIZES.MD]: {
      mainView: {
        borderRadius: 10,

        width: "70%",

        marginHorizontal: 40,
        marginVertical: 75,
        // alignSelf: "center",
        // flex: 1,
      },
      allView: {
        padding: 10,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 20,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        // height: "30%",
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "55%",
      },

      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
      playerImg: {
        height: 51,
        width: 51,
        marginVertical: 10,
      },
      vsImage: {
        width: 70,
        height: 70,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "60%",
        marginHorizontal: 40,
        marginVertical: 65,
        alignSelf: "center",
        // flex: 1,
      },
      allView: {
        padding: 30,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 20,
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        // height: "30%",
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "52%",
      },

      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "80%",
        marginHorizontal: 40,
        marginVertical: 90,
        alignSelf: "center",
        // flex: 1,
      },
      allView: {
        padding: 10,

        paddingHorizontal: 10,
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      detailTextStyle: {
        height: 100,
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 20,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,

        borderRadius: 10,
        height: "20%",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "55%",
      },
      playerImg: {
        height: 96,
        width: 80,
      },

      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      detailTextStyle: {
        height: 100,
      },
      mainView: {
        width: "95%",
        marginHorizontal: 40,
        marginVertical: 40,
        alignSelf: "center",
        // flex: 1,
      },
      allView: {
        padding: 10,
        borderRadius: 10,
        paddingHorizontal: 10,
      },
      wrraperView: {
        flexDirection: "row",

        paddingVertical: 10,
      },
      playerImg: {
        height: 96,
        width: 80,
      },
      streamerView: {
        backgroundColor: AppColors.grayColor_333333,
        // height: "30%",
        borderRadius: 10,
      },
      streamViewStyle: {
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
      priceView: {
        backgroundColor: AppColors.grayColor_333333,
        marginTop: 5,
        borderRadius: 10,
        width: "40%",
      },
      textInput: {
        paddingVertical: 12,
        paddingHorizontal: 60,
        backgroundColor: AppColors.black,
        margin: 5,
        borderRadius: 10,
      },

      btnSignUpStyle: {
        marginVertical: 10,
        paddingVertical: 0,
        paddingHorizontal: 20,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        height: 30,
        borderRadius: 7,
        alignSelf: "center",
        top: 10,
      },
      deviceDirection: {
        flexDirection: "column",
        // gap: 110,
      },
      vsImage: {
        width: 50,
        height: 100,
        marginVertical: 10,
      },
    },
  }
);
